<form [formGroup]="form">
  <div class="configuration-container">
    <app-top-section [form]="getTopSectionDetails"></app-top-section>
    <!--- GSL CONFIGURATIONS --->
    <ion-row class="configuration-section">
      <ion-col size="12">
        <h3 class="heading">
          {{ SECTIONS.GSL_CONFIGURATIONS.header }}
        </h3>
      </ion-col>
    </ion-row>
    <ion-row class="configuration-section-end">
      @for (item of SECTIONS.GSL_CONFIGURATIONS.data; track item) {
        <ion-col [size]="item.expanded ? 12 : 3">
          <app-config-item
            [inputData]="item"
            [form]="getConfig('gslConfigurations')"
            (toggleExpand)="item.expanded = $event"
          >
            @switch (item.expandableIndex) {
              @case (0) {
                <app-edi-setting [form]="getGslConfig('ediDetails')">
                </app-edi-setting>
              }
              @case (1) {
                <app-ftp-scan-events-setting
                  [form]="getConfig('gslConfigurations')"
                ></app-ftp-scan-events-setting>
              }
              @case (2) {
                <app-revenue-recovery-setting
                  [form]="getGslConfig('revenueRecoveryDetails')"
                  [initialVals]="
                    form.get('gslConfigurations')?.get('revenueRecoveryDetails')
                      ?.value
                  "
                  [unit]="unit"
                ></app-revenue-recovery-setting>
              }
              @case (3) {
                <app-default-sort-schedule-setting
                  [form]="getGslConfig('sortScheduleDetails')"
                ></app-default-sort-schedule-setting>
              }
            }
          </app-config-item>
        </ion-col>
      }
    </ion-row>
    <!---------------------------->

    <!--- CUSTOMER --->
    <ion-row class="configuration-section">
      <ion-col size="12">
        <h3 class="heading">
          {{ SECTIONS.CUSTOMER.header }}
        </h3>
      </ion-col>
    </ion-row>
    <ion-row class="configuration-section-end">
      @for (item of SECTIONS.CUSTOMER.data; track item; let index = $index) {
        <ion-col [size]="item.expanded ? 12 : 3">
          <app-config-item
            [inputData]="item"
            [form]="getConfig('customerConfigs')"
            [disable]="checkCvisSmartDisabled(item)"
            (toggleExpand)="item.expanded = $event"
          >
            @switch (item.expandableIndex) {
              @case (0) {
                <app-customer-location-setting
                  [form]="getConfig('customerConfigs')"
                ></app-customer-location-setting>
              }
              @case (1) {
                <app-cvis-smart-enabled-setting
                  [form]="getCustomerConfig('cvisSmartDetails')"
                ></app-cvis-smart-enabled-setting>
              }
            }
          </app-config-item>
        </ion-col>
      }
    </ion-row>
    <!---------------------------->

    <!--- EQUIPMENT HANDLING --->
    <ion-row class="configuration-section">
      <ion-col size="12">
        <h3 class="heading">
          {{ SECTIONS.EQUIPMENT_HANDLING.header }}
        </h3>
      </ion-col>
    </ion-row>
    <ion-row class="configuration-section-end">
      @for (item of SECTIONS.EQUIPMENT_HANDLING.data; track item) {
        <ion-col [size]="item.expanded ? 12 : 3">
          <app-config-item
            [inputData]="item"
            [form]="getConfig('equipmentHandling')"
            (toggleExpand)="item.expanded = $event"
          ></app-config-item>
        </ion-col>
      }
    </ion-row>
    <!---------------------------->

    <!--- EXTERNAL SYSTEMS --->
    <ion-row class="configuration-section">
      <ion-col size="12">
        <h3 class="heading">
          {{ SECTIONS.EXTERNAL_SYSTEMS.header }}
        </h3>
      </ion-col>
    </ion-row>
    <ion-row class="configuration-section-end">
      @for (item of SECTIONS.EXTERNAL_SYSTEMS.data; track item) {
        <ion-col [size]="item.expanded ? 12 : 3">
          <app-config-item
            [inputData]="item"
            [form]="getConfig('externalSystems')"
            (toggleExpand)="item.expanded = $event"
          >
          </app-config-item>
        </ion-col>
      }
    </ion-row>
    <!---------------------------->
  </div>
</form>
